import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import { isPathnameExcluded, isLoaderEnabled, hasDeviceModelParam } from './helpers';
import { LOADER_KEY, SHOW_LOADER, HIDE_LOADER } from './constants';

export const useShowAppLoader = (isInitialLoader = false) => {
  const { pathname, search } = useLocation()
  const loaderConfig = useSelector(selectMetadataKeyByRegion(LOADER_KEY));

  const shouldHideLoader = [
    !isInitialLoader,
    isPathnameExcluded(pathname),
    !isLoaderEnabled(loaderConfig),
    hasDeviceModelParam(search)
  ].some(Boolean);

  return shouldHideLoader ? HIDE_LOADER : SHOW_LOADER;
}